import React from "react"
import DashboardControls from "../components/DashboardControls"
import DashboardSummary from "./DashboardSummary.controller"
import DashboardCharts from "./DashboardCharts.controller"

const DashboardContent = () => {
  return (
    <div className="dashboard-content">
      <DashboardControls />
      <DashboardSummary />
      <DashboardCharts />
    </div>
  )
}

export default DashboardContent
